export type PdfHeaderKind = 'pdf' | 'ole2' | 'unknown';

const PDF_SIGNATURE = [0x25, 0x50, 0x44, 0x46];
const OLE2_SIGNATURE = [0xd0, 0xcf, 0x11, 0xe0, 0xa1, 0xb1, 0x1a, 0xe1];
const PDF_SIGNATURE_SCAN_LIMIT = 1024;
const MICROSOFT_IRM_PAYLOAD_MARKER = 'MicrosoftIRMServices';

const startsWith = (bytes: Uint8Array, signature: number[]): boolean =>
  signature.every((byte, index) => bytes[index] === byte);

const containsSignature = (
  bytes: Uint8Array,
  signature: number[],
  limit: number
): boolean => {
  const lastStart = Math.min(bytes.length, limit) - signature.length;
  for (let i = 0; i <= lastStart; i++) {
    if (signature.every((byte, j) => bytes[i + j] === byte)) return true;
  }
  return false;
};

export const classifyPdfHeader = (bytes: Uint8Array): PdfHeaderKind => {
  if (startsWith(bytes, OLE2_SIGNATURE)) return 'ole2';
  if (containsSignature(bytes, PDF_SIGNATURE, PDF_SIGNATURE_SCAN_LIMIT)) {
    return 'pdf';
  }
  return 'unknown';
};

/**
 * Whether the pdf.js attachments include the encrypted body of a PDF
 * protected by Microsoft information protection. Such a PDF opens without
 * error but shows only a "this PDF is protected" cover page.
 */
export const hasMicrosoftIrmPayload = (
  attachments: Record<string, { filename: string }> | null
): boolean =>
  Object.values(attachments ?? {}).some(({ filename }) =>
    filename.includes(MICROSOFT_IRM_PAYLOAD_MARKER)
  );
